import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

const tableURlMapping = {
  drmBidTableData: URLS.DRM_BID_TABLE_DETAILS,
  drmDailyTableData: URLS.DRM_DAILY_TABLE_DETAILS,
  drmChangeLogTableData: URLS.DRM_CHANGE_LOG_TABLE_DETAILS,
  drmCoupaFileDeleteDetails: URLS.DRM_COUPA_FILE_DELETE_DETAILS,
  drmCeaProfileList: URLS.DRM_CEA_PROFILE_LIST,
};

export const fetchDrmTableData = async ([
  pageNum,
  reqBody,
  pageSize,
  tableName,
  controller,
]) => {
  const response = await axios.post(
    `${tableURlMapping[tableName]}?pageNum=${pageNum}&pageSize=${pageSize}`,
    reqBody,
    { signal: controller.signal }
  );

  if (response.status >= 400) {
    throw new Error(response.message);
  }
  return response;
};
